import { StyledAdjustableRow, StyledCol, StyledInput, StyledRow } from '@/shared/styles';
import { StyledBottomText, StyledInputRow } from '../ScanUrl.styles';
import { Icon } from '@/shared/components/Icon';
import { U1Button } from '@/shared/components/Button/U1Button';
import { complianceExamples, ScanInputSectionProps } from '../ScanUrl.consts';
import { checkIcon, globalIcon } from '@/assets/images/icons';
import { useTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';
import { useState } from 'react';
import { urlRegex } from '@/shared/regex';

export const ScanInputSection: React.FC<ScanInputSectionProps> = ({
  onScan,
}: ScanInputSectionProps) => {
  const { t } = useTranslation();
  const [websiteUrl, setWebsiteUrl] = useState('');

  const isValidUrl = () => {
    return !!(websiteUrl && websiteUrl.match(urlRegex));
  };

  const scanUrl = () => {
    let finalUrl = websiteUrl;

    if (websiteUrl.includes('http://')) {
      finalUrl = finalUrl.replace('http://', 'https://');
    } else if (!websiteUrl.includes('https://')) {
      finalUrl = `https://${websiteUrl}`;
    }

    onScan(finalUrl);
  };

  return (
    <StyledCol $gap={24} $width="100%">
      <StyledInputRow>
        <StyledInput
          placeholder={t('free_tools.accessibility_checker.scan_url.placeholder')}
          prefix={<Icon $src={globalIcon} />}
          width="100%"
          value={websiteUrl}
          onChange={(e) => setWebsiteUrl(e.target.value)}
        />
        <U1Button
          text={t('free_tools.accessibility_checker.scan_url.start_scan')}
          $width={isMobileOnly ? '100%' : '45%'}
          onClick={scanUrl}
          disabled={!isValidUrl()}
        />
      </StyledInputRow>
      <StyledAdjustableRow $gap={8} $wrap="wrap">
        <StyledBottomText>
          {t('free_tools.accessibility_checker.scan_url.check_compliances')}:
        </StyledBottomText>
        {complianceExamples.map((comp, i) => (
          <StyledRow key={`comp${i}`} $gap={8}>
            <Icon $src={checkIcon} />
            <StyledBottomText>{comp}</StyledBottomText>
          </StyledRow>
        ))}
      </StyledAdjustableRow>
    </StyledCol>
  );
};
